<div class="tw-flex tw-justify-end tw-items-center">
    <button mat-icon-button (click)="onDialogClose(true)">
        <mat-icon aria-label="Close dialog">close</mat-icon>
    </button>
</div>
<div mat-dialog-content class=>
    <div>
        <!-- Filter Start -->
        <div
            class="tw-inline-flex tw-text-base tw-pb-3 tw-items-center tw-font-semibold tw-text-black"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                class="tw-me-2"
            >
                <path
                    d="M9.34062 18.875V13.9531H10.6531V15.7688H18.375V17.0813H10.6531V18.875H9.34062ZM2.625 17.0813V15.7688H8.02812V17.0813H2.625ZM6.71562 13.45V11.6562H2.625V10.3438H6.71562V8.50625H8.02812V13.45H6.71562ZM9.34062 11.6562V10.3438H18.375V11.6562H9.34062ZM12.9719 8.04688V3.125H14.2844V4.91875H18.375V6.23125H14.2844V8.04688H12.9719ZM2.625 6.23125V4.91875H11.6594V6.23125H2.625Z"
                    fill="black"
                />
            </svg>
            {{ "PRODUCT_MATCHING.FILTER" | translate }}
        </div>
        <div
            class="tw-border-b-[1px] tw-border-caption-gray tw-opacity-50 tw-mb-4"
        ></div>
        <div role="none" class="tw-text-black tw-pb-8">
            <div class="tw-py-1 tw-flex tw-items-center">
                <input
                    [checked]="data.checkboxState['Provider']"
                    (click)="data.onFilterProduct($event,'Provider')"
                    type="checkbox"
                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                />
                <span class="tw-text-base tw-font-semibold">
                    {{ "PRODUCT_MATCHING.PROVIDER" | translate }}
                </span>
            </div>
            <div class="tw-pl-6 tw-pb-4">
                <div class="tw-py-1 tw-flex tw-items-center">
                    <input
                        [checked]="data.checkboxState['BANK']"
                        (click)="data.onFilterProduct($event,'BANK')"
                        type="checkbox"
                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                    />
                    <span class="tw-text-base tw-font-semibold">
                        {{ "COMMON.BANKS" | translate }}</span
                    >
                </div>
                <div class="tw-py-1 tw-flex tw-items-center">
                    <input
                        [checked]="data.checkboxState['P2P']"
                        (click)="data.onFilterProduct($event,'P2P')"
                        type="checkbox"
                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                    />
                    <span class="tw-text-base tw-font-semibold">P2P</span>
                </div>
                <div class="tw-py-1 tw-flex tw-items-center">
                    <input
                        [checked]="data.checkboxState['CGC']"
                        (click)="data.onFilterProduct($event,'CGC')"
                        type="checkbox"
                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                    />
                    <span class="tw-text-base tw-font-semibold">CGC</span>
                </div>
            </div>
            <div
                class="tw-border-b-2 tw-border-placeholder-gray tw-ms-5 tw-opacity-10"
            ></div>
            <div class="tw-pb-1 tw-flex tw-pt-4 tw-items-center">
                <input
                    [checked]="data.checkboxState['Type']"
                    (click)="data.onFilterProduct($event,'Type')"
                    type="checkbox"
                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                />
                <span class="tw-text-base tw-font-semibold">
                    {{ "PRODUCT_MATCHING.TYPE" | translate }}</span
                >
            </div>
            <div class="tw-pl-6">
                <div class="tw-py-1 tw-flex tw-items-center">
                    <input
                        [checked]="data.checkboxState['isIslamic']"
                        (click)="data.onFilterProduct($event,'isIslamic')"
                        type="checkbox"
                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                    />
                    <span class="tw-text-base tw-font-semibold">
                        {{ "PRODUCT_MATCHING.ISLAMIC" | translate }}</span
                    >
                </div>
                <div class="tw-py-1 tw-flex tw-items-center">
                    <input
                        [checked]="data.checkboxState['isConventional']"
                        (click)="data.onFilterProduct($event,'isConventional')"
                        type="checkbox"
                        class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                    />
                    <span class="tw-text-base tw-font-semibold">
                        {{ "PRODUCT_MATCHING.CONVENTIONAL" | translate }}</span
                    >
                </div>
            </div>
        </div>
        <!-- Filter END -->

        <!-- Sort By Start -->
        <div
            class="tw-inline-flex tw-pb-3 tw-text-base tw-items-center tw-font-semibold tw-text-black"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                class="tw-me-2"
            >
                <path
                    d="M2.625 16.25V14.5H7.875V16.25H2.625ZM2.625 11.875V10.125H13.125V11.875H2.625ZM2.625 7.5V5.75H18.375V7.5H2.625Z"
                    fill="black"
                />
            </svg>
            {{ "PRODUCT_MATCHING.SORT_BY" | translate }}
        </div>
        <div
            class="tw-border-b-[1px] tw-border-caption-gray tw-opacity-50 tw-mb-4"
        ></div>
        <div class="tw-text-black">
            <button
                class="tw-py-3 tw-ps-2 tw-pe-4  {{
                    selectedSortBy == 0
                        ? 'tw-bg-[#4B6EEC] tw-text-white'
                        : ''
                }} tw-flex tw-items-center tw-text-base tw-w-full tw-text-left tw-font-semibold"
                (click)="data.onSortProduct(0); selectedSortBy = 0"
            >
                <div class="tw-me-2">
                    <mat-icon class="{{
                        selectedSortBy == 0
                            ? 'tw-text-white'
                            : ''
                    }}" fontIcon="arrow_outward"></mat-icon>
                </div>
                {{ "PRODUCT_MATCHING.INTEREST_RATE_HIGH_LOW" | translate }}
            </button>
            <div class="tw-pl-7">
                <hr />
            </div>

            <button
                class="tw-py-3 tw-ps-2 tw-pe-4  {{
                    selectedSortBy == 1
                        ? 'tw-bg-[#4B6EEC] tw-text-white'
                        : ''
                }} tw-flex tw-items-center tw-text-base tw-w-full tw-text-left tw-font-semibold"
                (click)="data.onSortProduct(1); selectedSortBy = 1"
            >
                <div class="tw-me-2">
                    <mat-icon class="{{
                        selectedSortBy == 1
                            ? 'tw-text-white'
                            : ''
                    }}" fontIcon="arrow_outward"></mat-icon>
                </div>
                {{ "PRODUCT_MATCHING.INTEREST_RATE_LOW_HIGH" | translate }}
            </button>
            <div class="tw-pl-7">
                <hr />
            </div>
            <button
                class="tw-py-3 tw-ps-2 tw-pe-4  {{
                    selectedSortBy == 2
                        ? 'tw-bg-[#4B6EEC] tw-text-white'
                        : ''
                }} tw-flex tw-items-center tw-text-base tw-w-full tw-text-left tw-font-semibold"
                (click)="data.onSortProduct(1); selectedSortBy = 2"
            >
                <div class="tw-me-2">
                    <mat-icon class="{{
                        selectedSortBy == 2
                            ? 'tw-text-white'
                            : ''
                    }}" fontIcon="arrow_outward"></mat-icon>
                </div>
                {{ "PRODUCT_MATCHING.PROCESSING_HIGH_LOW" | translate }}
            </button>
            <div class="tw-pl-7">
                <hr />
            </div>
            <button
                class="tw-py-3 tw-ps-2 tw-pe-4 tw-flex tw-items-center {{
                    selectedSortBy == 3
                        ? 'tw-bg-[#4B6EEC] tw-text-white'
                        : ''
                }} tw-text-base tw-w-full tw-text-left tw-font-semibold"
                (click)="data.onSortProduct(3); selectedSortBy = 3"
            >
                <div class="tw-me-2">
                    <mat-icon class="{{
                        selectedSortBy == 3
                            ? 'tw-text-white'
                            : ''
                    }}" fontIcon="arrow_outward"></mat-icon>
                </div>
                {{ "PRODUCT_MATCHING.PROCESSING_LOW_HIGH" | translate }}
            </button>
        </div>
        <!-- Sort By End -->
    </div>
</div>
